import React, { useEffect, useRef } from 'react'
import './Services.css'
// import { FaPaintBrush } from 'react-icons/fa'
import { BsCodeSquare } from 'react-icons/bs'
import { SiCoinmarketcap } from "react-icons/si";

// import { TfiWrite } from 'react-icons/tfi'
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { FaDatabase } from "react-icons/fa";


const Services = () => {
  const container = useRef(null)
  gsap.registerPlugin(ScrollTrigger)

  useEffect(() => {
    const el = container.current
    gsap.fromTo('.service__head', {
      opacity: 0,
    },
      {
        opacity: 1,
        scrollTrigger: {
          trigger: el,

        }
      }
    )
    gsap.fromTo('.service', {
      y: -50,
      opacity: 0,
    }, {
      y: 0,
      opacity: 1,
      duration: 1,
      scrollTrigger: {
        trigger: el,
        start: '-100% bottom',
        end: 'bottom 20%',
        scrub: true
      }
    })
  }, [])
  return (
    <section id='services'>
      <div className='section__wrapper services__wrapper'>
        <div className="section__header center">
          <h2 className="primary__title">Services</h2>
          <p className="text__muted description">
            I transform your ideas, and consequently your desires, into a
            distinctive web project that both inspires you and captivates your customers.
          </p>
        </div>
        <div className="services__group">
          <article className="service">
            <div className="service__top">
              <div className="icon__container">
                <FaDatabase  className='icon' />
              </div>
              <h3 className="title">Database Administration</h3>
            </div>
            <div className="service__middle">
              <p className="text__muted description">
                Expertise in managing and optimizing databases, ensuring data integrity, implementing security measures, and performing backups and recovery.
                Skilled in database performance tuning and troubleshooting to ensure efficient and reliable data management.
              </p>
            </div>
            <div className="service__bottom">
              <div className="btn btn__primary">Read more</div>
            </div>
          </article>
          {/* End ui/ux */}


          <article className="service" style={{ '--color-primary': 'var(--color-success)' }}>
            <div className="service__top">
              <div className="icon__container">
                <BsCodeSquare className='icon' />
              </div>
              <h3 className="title">Website Development</h3>
            </div>
            <div className="service__middle">
              <p className="text__muted description">
                Proficiency in designing and developing responsive websites using modern web technologies.
                Experience in front-end and back-end development, creating intuitive user interfaces, integrating with APIs, and ensuring cross-browser compatibility.
              </p>
            </div>
            <div className="service__bottom">
              <div className="btn btn__primary">Read more</div>
            </div>
          </article>
          {/* End Web development */}


          <article className="service" style={{ '--color-primary': 'blueviolet' }}>
            <div className="service__top">
              <div className="icon__container">
                <SiCoinmarketcap  className='icon' />
              </div>
              <h3 className="title">Digital Marketing Specialist</h3>
            </div>
            <div className="service__middle">
              <p className="text__muted description">
              Specializing in developing and executing digital marketing strategies. Proficient in SEO, content marketing, social media management, and PPC advertising.
               Track record of driving website traffic, improving online visibility, and increasing customer engagement and conversions.
              </p>
            </div>
            <div className="service__bottom">
              <div className="btn btn__primary">Read more</div>
            </div>
          </article>
          {/* End content creation */}
        </div>
      </div>
    </section>
  )
}

export default Services